export default __webpack_public_path__ + "static/backgroundAwards-2d041e5c57b75fc9b7afdb43656ec83e.webp";